import { call, put, takeEvery, fork, cancel, cancelled, takeLatest } from 'redux-saga/effects';
import { ApiResponse, CancelToken } from 'apisauce';
import { HealAPI } from '../../healApi';
import { setAreas, ViewingBoundsChanged, PatchArea, CreateArea, DeleteArea } from './actions';
import { store } from '../../redux/store';
import { Area } from './types';
import { toast } from '../../redux/message/actions';

let runningIntersectRequest: any | undefined;

function* patchArea(patchAreaEvent: PatchArea) {
  const areaToPatch = patchAreaEvent.data;

  let existingAreas: Area[] = store.getState().marketMap.loadedAreas.slice();

  const response: ApiResponse<Area> = yield call(HealAPI.patchArea, areaToPatch);

  let patchedArea: Area | undefined = undefined;

  if (response.ok) {
    patchedArea = response.data;
  } else {
    yield put(toast({ title: 'Error', content: (response.data as any).message, type: 'error' }));
  }

  existingAreas = existingAreas.map((m) => {
    if (patchedArea && m.id === areaToPatch.id) {
      return patchedArea;
    } else {
      return m;
    }
  });
  yield put(setAreas(existingAreas));
}

function* deleteArea(deleteAreaEvent: DeleteArea) {
  const areaToPatch = deleteAreaEvent.data;

  let existingAreas: Area[] = store.getState().marketMap.loadedAreas.slice();

  const response: ApiResponse<Area> = yield call(HealAPI.deleteArea, areaToPatch);

  let deletedArea: Area | undefined = undefined;

  if (response.ok) {
    deletedArea = response.data;
  } else {
    yield put(toast({ title: 'Error', content: (response.data as any).message, type: 'error' }));
  }

  existingAreas = existingAreas.filter((m) => {
    if (deletedArea && m.id === areaToPatch.id) {
      return false;
    } else {
      return true;
    }
  });
  yield put(setAreas(existingAreas));
}

function* createArea(createAreaEvent: CreateArea) {
  const areaToPatch = createAreaEvent.data;

  const existingAreas: Area[] = store.getState().marketMap.loadedAreas.slice();

  const response: ApiResponse<Area> = yield call(HealAPI.createArea, areaToPatch);

  let patchedArea: Area | undefined = undefined;

  if (response.ok) {
    patchedArea = response.data;
  } else {
    yield put(toast({ title: 'Error', content: (response.data as any).message, type: 'error' }));
  }

  if (patchedArea) {
    existingAreas.push(patchedArea);
  }

  yield put(setAreas(existingAreas));
}

function* doIntersectApiRequest(geojsonPolygon: any): any {
  const scopedRequestCancelToken = CancelToken.source();

  try {
    const response: ApiResponse<any> = yield call(HealAPI.fetchAreasByIntersection, geojsonPolygon, scopedRequestCancelToken.token);

    if (response.ok) {
      const areas = response.data;
      runningIntersectRequest = undefined;
      yield put(setAreas(areas));
    } else if (response.problem === 'CANCEL_ERROR') {
      // do nothing, request was cancelled
    } else if (response.data && response.data.message) {
      runningIntersectRequest = undefined;
      yield put(toast({ title: 'Error', content: (response.data as any).message, type: 'error' }));
    }
  } finally {
    if (yield cancelled()) {
      // handle the SAGA request cancellationk and cancel the scoped api request
      scopedRequestCancelToken.cancel();
    }
  }
}

function* loadAreas(viewingBoundsDidChange: ViewingBoundsChanged): any {
  if (runningIntersectRequest) {
    yield cancel(runningIntersectRequest);
  }

  // eslint-disable-next-line
  runningIntersectRequest = yield fork(doIntersectApiRequest, viewingBoundsDidChange.data);
}

export function* marketMapFlow() {
  yield takeLatest(['MARKET_MAP_VIEWING_BOUNDS_CHANGED'], loadAreas);
  yield takeEvery(['MARKET_MAP_PATCH_AREA'], patchArea);
  yield takeEvery(['MARKET_MAP_CREATE_AREA'], createArea);
  yield takeEvery(['MARKET_MAP_DELETE_AREA'], deleteArea);
}
